// BaseIcon.tsx

import { FC, ReactElement, cloneElement } from 'react';
import { SvgIconProps } from '@mui/material';
import { useThemeStore } from '@host/stores';

interface BaseIconProps extends SvgIconProps {
  icon: ReactElement; // Outlined version
  filledIcon?: ReactElement; // Optional filled version
  variant?: 'outlined' | 'filled';
}

const BaseIcon: FC<BaseIconProps> = ({
  icon,
  filledIcon,
  variant = 'outlined',
  fontSize = 'small',
  color = 'inherit',
  sx = {},
  ...rest
}) => {
  const themeColors = useThemeStore((s) => s.themeColors);

  const isCustomColor = !(
    color === 'inherit' ||
    color === 'primary' ||
    color === 'secondary' ||
    color === 'error'
  );

  const resolvedSx = {
    ...sx,
    ...(isCustomColor && {
      color: themeColors[color as keyof typeof themeColors] || color,
    }),
  };

  const selectedIcon = variant === 'filled' && filledIcon ? filledIcon : icon;

  return cloneElement(selectedIcon, {
    fontSize,
    color: isCustomColor ? 'inherit' : color,
    sx: resolvedSx,
    ...rest,
  });
};

export default BaseIcon;
